import { render, staticRenderFns } from "./submit-review.vue?vue&type=template&id=fb36349a&scoped=true&"
import script from "./submit-review.vue?vue&type=script&lang=js&"
export * from "./submit-review.vue?vue&type=script&lang=js&"
import style0 from "./submit-review.vue?vue&type=style&index=0&id=fb36349a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb36349a",
  null
  
)

export default component.exports